/**
 * スムーズな <details> 開閉アニメーション
 *
 * 対象: <details data-details-anim>
 * 必須構造: summary と <div data-details-content> を含む
 */
export function initDetailsAnimator() {
	const animatedDetails = document.querySelectorAll('details[data-details-anim]');

	animatedDetails.forEach((details) => {
		const content = details.querySelector('[data-details-content]');
		if (!content) return;

		// 初期スタイルを適用
		Object.assign(content.style, {
			overflow: 'hidden',
			height: details.open ? content.scrollHeight + 'px' : '0px',
			transition: 'height .2s ease',
		});

		// 開閉アニメーション処理
		details.addEventListener('toggle', () => {
			if (details.open) {
				content.style.height = content.scrollHeight + 'px';
			} else {
				content.style.height = content.scrollHeight + 'px';
				requestAnimationFrame(() => {
					content.style.height = '0px';
				});
			}
		});
	});
}
